export default __webpack_public_path__ + "static/media/ai-grey.be094500.svg";